import $ from 'jquery';
// eslint-disable-next-line no-unused-vars
import select2 from 'select2';

export default {
  init() {
    const celebrityEl = $('[name="celebrity"]');
    const postsEl = $('[name="nbr_posts"]'); 
    const storiesEl = $('[name="nbr_stories"]');
    const exclusivityEl = $('[name="exclusivity"]');

    celebrityEl.on('change',function(){
        calculate();
    });

    postsEl.on('change',function(){
        calculate();
    });

    storiesEl.on('change',function(){
        calculate();
    });

    exclusivityEl.on('change',function(){
        calculate();
    });

    const calculate = () => {
      const number_posts = postsEl.val();
      const number_stories = storiesEl.val();
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: window.ajax_object.ajaxurl,
            data: { 
                action: 'calculate_celebrity_cost',
                celebrity: celebrityEl.val(),
                number_posts: number_posts,
                number_stories: number_stories,
                exclusivity: exclusivityEl.val(),
                nonce: window.ajax_object.nonce,
            },
            success: response => {
              if(response.price){
                let price = "";
                if(! isNaN(parseInt(number_posts, 10)) && ! isNaN(parseInt(number_stories, 10)) ){
                    price = number_posts + ' post och ' + number_stories + ' story';
                }else if(! isNaN(parseInt(number_posts, 10)) ){
                    price = number_posts + ' post';
                }else if(! isNaN(parseInt(number_stories, 10)) ){
                    price = number_stories + ' story';
                }else{
                    $('.budget-result').html( '' );
                    return;
                }
                let html = '<h4 class="w-full text-l text-white text-center leading-normal"> Det totala priset för ' + price + '</h4>';
                html += '<div class="calculator-price text-2xl text-center mt-4">' + response.price.toLocaleString() + ' kr (ex moms)</div>';
                html += '<div class="disclaminer leading-normal text-sm mt-4 text-center">Priset är ett estimat, detta måste godkännas av Celebriteten innan bekräftelse</div>';
                $('.budget-result').html( html );
                if(response.image){
                  $('.audience-image').attr("src", response.image);
                  $('.audience-image').removeClass("hidden");
                }else{
                  $('.audience-image').removeAttr("src");
                  $('.audience-image').addClass("hidden");
                }
              }else if(response.image){
                $('.audience-image').attr("src", response.image);
                $('.audience-image').removeClass("hidden");
              }else{
                $('.budget-result').html( '' );
                $('.audience-image').removeAttr("src");
                $('.audience-image').addClass("hidden");
              }
            },
        });
    };
  },
  finalize() {
    if ($('.select2').length) {
      $('.select2').select2({
        multiple: false,
      });
      $(".select2-selection__arrow")
      .addClass("material-icons")
      .html("expand_more");
    }
  },
};
